import api from "../../../api";

const DEVICE_CACHE_TTL_MS = 5 * 60 * 1000;
const deviceOnlyRequests = new Map();

function deviceRequestKey(options = {}) {
  return JSON.stringify({
    type: options.type || null,
    scope: options.scope || null,
  });
}

export default {
  async getPowerDevices({ commit }, _type) {
    commit("REQUEST_POWER_DEVICES");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_POWER_DEVICES",
        await api.getDevices({ type: _type.type })
      );
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_POWER_DEVICES");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async getPowerDevicesOnly({ commit, state }, options = {}) {
    const key = deviceRequestKey(options);
    const cacheIsFresh = state.statusOnly === "success" &&
      state.powerDevicesOnlyKey === key &&
      Date.now() - state.powerDevicesOnlyLoadedAt < DEVICE_CACHE_TTL_MS;
    if (!options.force && cacheIsFresh) return state.powerDevicesOnly;
    if (deviceOnlyRequests.has(key)) return deviceOnlyRequests.get(key);

    const request = (async () => {
      commit("REQUEST_POWER_DEVICESONLY");
      if (!options.silent) commit("SET_LOADING", true, { root: true });
      try {
        const result = await api.getDevicesOnly({
          type: options.type,
          scope: options.scope,
        });
        commit("SUCCESS_REQUEST_POWER_DEVICESONLY", result);
        commit("SET_POWER_DEVICESONLY_CACHE", { loadedAt: Date.now(), key });
        return result.body;
      } catch (err) {
        if (!err.ok && err.status === 401) {
          commit("TO_LOGIN", true, { root: true });
        }
        commit("FAILURE_REQUEST_POWER_DEVICESONLY");
        return null;
      } finally {
        if (!options.silent) commit("SET_LOADING", false, { root: true });
      }
    })();

    deviceOnlyRequests.set(key, request);
    try {
      return await request;
    } finally {
      deviceOnlyRequests.delete(key);
    }
  },
  async getDevicesAll({ commit }) {
    commit("REQUEST_DEVICESALL");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_DEVICESALL",
        await api.getDevicesAll()
      );
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_DEVICESALL");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async updateDeviceLocation({ commit }, item) {
    commit("REQUEST_UPDATE_DEVICELOCATION");
    commit("SET_LOADING", true, { root: true });
    try {
      const result = await api.updateDeviceLocation(item);
      commit("SUCCESS_REQUEST_UPDATE_DEVICELOCATION", result);
      commit("UPSERT_POWER_DEVICE_ONLY", result.body);
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_UPDATE_DEVICELOCATION");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async activateDeviceDryRun({ commit }, deviceId) {
    commit("SET_LOADING", true, { root: true });
    try {
      return await api.activateDeviceDryRun(deviceId);
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async migrateDeviceMqtt({ commit }, deviceId) {
    commit("SET_LOADING", true, { root: true });
    try {
      return await api.migrateDeviceMqtt(deviceId);
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async getDevice({ commit }, item) {
    //console.log("getDevice action")
    commit("REQUEST_POWER_DEVICE");
    commit("SET_LOADING", true, { root: true });
    try {
      const result = await api.getDevice({id: item._id, from: item.from});
      commit("SUCCESS_REQUEST_POWER_DEVICE", result);
      return result.body;
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_POWER_DEVICE");
      return null;
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async updateDeviceConfig({ commit }, item) {
    //console.log(item)
    commit("REQUEST_UPDATE_DEVICECONFIG");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_UPDATE_DEVICECONFIG",
        await api.updateDeviceConfig(item)
      );
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_UPDATE_DEVICECONFIG");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async getDeviceDebugValues({ commit }, item) {
    commit("REQUEST_POWER_DEVICE_DEBUG_VALUES");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_POWER_DEVICE_DEBUG_VALUES",
        await api.getDeviceDebugValues({id: item._id})
      );
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_POWER_DEVICE_DEBUG_VALUES");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async setDevice({ commit }, item) {
    //console.log(item)
    commit("REQUEST_UPDATE_SETDEVICE");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_UPDATE_SETDEVICE",
        await api.setDevice(item)
      );
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_UPDATE_SETDEVICE");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async getDeviceIFrame({ commit }, item) {
    commit("REQUEST_IFRAME_DEVICE");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_IFRAME_DEVICE",
        await api.getDeviceIFrame({id: item._id})
      );
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_IFRAME_DEVICE");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
};
